import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import {
  FIELD_LAYOUTS,
  ENUM_STYLES,
  TYPES
} from './types'

export const FIELD_SET_SCHEMA_SHAPE = {
  id: T.string,
  heading: T.string.isRequired,
  layout: T.oneOf(Object.keys(FIELD_LAYOUTS)),
  allRequired: T.bool,
  helperText: T.string,
  validate: T.func
}

export const EDITABLE_SHAPE = {
  validate: T.func,
  options: T.oneOfType([
    IT.list,
    T.func
  ]),
  maxAllowed: T.number,
  placeholder: T.string,
  helperText: T.string,
  type: T.oneOf(Object.keys(TYPES)), // Editable type may be provided to supercede the schema field (top level) type
  style: T.oneOf(Object.keys(ENUM_STYLES)),
  fieldSet: IT.mapContains(FIELD_SET_SCHEMA_SHAPE),

  // Only for SCHEMA
  layout: T.oneOf(Object.keys(FIELD_LAYOUTS)),
}

export const QUERYABLE_SHAPE = {
  validate: T.func,
  options: T.oneOfType([
    IT.list,
    T.func
  ]),
  maxAllowed: T.number,
  placeholder: T.string,
  helperText: T.string,
  type: T.oneOf(Object.keys(TYPES)), // Queryable type may be provided to supercede the schema field (top level) type
  style: T.oneOf(Object.keys(ENUM_STYLES)),
}

export const SCHEMA_ITEM_SHAPE = IT.mapContains({
  type: T.oneOf(Object.keys(TYPES)),
  display: T.string,
  path: T.oneOfType([
    T.string,
    IT.mapContains({
      get: T.string,
      set: T.string
    })
  ]),
  required: T.bool,
  tooltip: T.string,
  normalize: T.func,
  denormalize: T.func,
  alwaysDenormalize: T.bool,
  creatable: T.oneOfType([
    T.bool,
    IT.mapContains(EDITABLE_SHAPE)
  ]),
  editable: T.oneOfType([
    T.bool,
    IT.mapContains(EDITABLE_SHAPE)
  ]),
  queryable: T.oneOfType([
    T.bool,
    IT.mapContains(QUERYABLE_SHAPE)
  ]),
})

export const COLUMN_SHAPE = IT.mapContains({
  // key: T.oneOfType([T.string, T.number]).isRequired,
  resizable: T.bool,
  sortable: T.bool,
  fixed: T.bool,
  stickyable: T.bool,
  format: T.func, // Cell value formatter
  width: T.oneOfType([T.number, T.func]),
  height: T.oneOfType([T.number, T.func]),
  headerHeight: T.oneOfType([T.number, T.func]),
  columns: IT.orderedMap // Nested columns
})

export const CUSTOM_INPUTS_SHAPE = IT.mapOf(
  T.func,
  T.string
)

export const FIELD_OPTIONS_SHAPE = IT.mapOf(
  T.oneOfType([
    T.array,
    T.func,
    IT.list
  ]),
  T.string // fieldName
)

export const SCHEMA_SHAPE = IT.orderedMapOf(
  SCHEMA_ITEM_SHAPE,
  T.oneOfType([T.string, T.number])
)